import { getReq } from '../../utils/request'
import { IUsersJobsTimeWorked } from '../../reducers/usersU/actions'

const fetchDashboardWorkTime = async (weeksBack: number = 0) => {
	const { data } = await getReq('/api/admin/users/jobs/work-time', {
		weeksBack
	})

	return data as IUsersJobsTimeWorked
}

export default fetchDashboardWorkTime
